// extracted by mini-css-extract-plugin
module.exports = {"link":"FaqLink_link__L2Wda"};